import { toPreownedCountryIso } from "./BasePathTools";
import { getAppContextFromCookie } from "./eventsBus";

const APP_CONTEXT_COOKIE = "recom-app-context";

export interface AppContext {
  hostName: string;
  langCode: string;
  langId: string;
  storeCode: string;
  storeId: string;
  version: string;
  knownEvents: string[];
  [key: string]: any;
}


export function getAppContext(): AppContext | null {
  return getAppContextFromCookie();
}

/** El storeCode del contexto nativo llega en mayusculas y con "GB" en vez del "uk" que usa preowned. */
export function getAppContextCountryIso(): string | null {
  const storeCode = getAppContext()?.storeCode;
  return storeCode ? toPreownedCountryIso(storeCode) : null;
}

/** El langCode del contexto nativo llega como locale ("es-ES", "en-GB"); la URL solo usa el idioma. */
export function getAppContextLanguage(): string | null {
  const langCode = getAppContext()?.langCode;
  return langCode ? langCode.split("-")[0].toLowerCase() : null;
}

export function isEventSupported(eventName: string): boolean {
  const appContext = getAppContext();
  return appContext?.knownEvents?.includes(eventName) || false;
}


export function setupMockAppContext(mockData: Partial<AppContext> = {}): void {
  const defaultData: AppContext = {
    hostName: "testHost",
    langCode: "en",
    langId: "1",
    storeCode: "es",
    storeId: "1",
    version: "4.5.6",
    knownEvents: [
      "sendAnalyticsEvent",
      "customEvent", 
      "onBarcodeScannerEvent",
      "openBarcodeScanner"
    ]
  };

  const mockAppContext = { ...defaultData, ...mockData };
  
  try {
    const cookieData = encodeURIComponent(JSON.stringify(mockAppContext));
    document.cookie = `${APP_CONTEXT_COOKIE}=${cookieData}; path=/; sameSite=strict`;
    console.log('[CookieUtils] Mock app context cookie set');
  } catch (error) {
    console.error('[CookieUtils] Error setting mock app context cookie:', error);
  }
}
